export const mapToSelectOptions = (items: { id: number | string; name: string }[] | undefined) => {
    return items?.map((item) => ({
        value: item.id.toString(),
        label: item.name,
    }));
};
